/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const banquetComboSchema = z.object({
	name: z.string(),
	amount: z.int(),
	price: z.number(),
});
